import {
  getVehiclePolls,
  longPersonVehicleHeaders,
  telematicsBoxPollHeaders,
} from '../../../apis/utilities';
import { ExportPicker } from '../../controls';

const { useReducedResourceInformation } = window.config;

const vehiclePollsHeaders = [
  ...longPersonVehicleHeaders,
  ...telematicsBoxPollHeaders,
];

export default function DownloadPollsLink({ entry }) {
  async function fetchDataToConvert() {
    const polls = await getVehiclePolls(
      entry.vehicle.telematicsBoxImei,
      entry.startTime,
      entry.endTime
    );

    const data = polls.map((poll) => ({
      ...poll,
      ...(useReducedResourceInformation
        ? { staffId: entry.driver.code }
        : {
            name: entry.driver.forenames + ' ' + entry.driver.surname,
            collarNumber: entry.driver.collarNumber,
            personRole: entry.driver.role,
          }),
      type: entry.vehicle.type,
      identificationNumber: entry.vehicle.identificationNumber,
      registrationNumber: entry.vehicle.registrationNumber,
      fleetNumber: entry.vehicle.fleetNumber,
      vehicleRole: entry.vehicle.role,
      collarNumber: entry.driver.collarNumber,
      time: new Date(poll.time),
      classification: entry.classification,
      rfidCards: entry.driver.identificationReference,
      imei: entry.vehicle.telematicsBoxImei,
    }));

    return data;
  }

  return (
    <ExportPicker
      title="Download Trip Polls"
      fetchDataToConvert={fetchDataToConvert}
      filename="Trip Polls"
      headers={vehiclePollsHeaders}
    />
  );
}
